export enum AcquisitionType {
  ORGANIC = 'ACQUISITION_TYPE_ORGANIC',
  PARTNER_REFERRAL = 'ACQUISITION_TYPE_PARTNER_REFERRAL',
}

export enum AddedVia {
  ACTIVE_VISIT_VIEW = 'ADDED_VIA_ACTIVE_VISIT_VIEW',
  APP = 'ADDED_VIA_APP',
  CUSTOMER_SUPPORT = 'ADDED_VIA_CUSTOMER_SUPPORT',
  ENTERPRISE = 'ADDED_VIA_ENTERPRISE',
  EXPRESS_ONBOARDING = 'ADDED_VIA_EXPRESS_ONBOARDING',
  GENERAL_ONBOARDING = 'ADDED_VIA_GENERAL_ONBOARDING',
  PAYMENT_OVERDUE = 'ADDED_VIA_PAYMENT_OVERDUE',
  POS = 'ADDED_VIA_POS',
  PROMOTION = 'ADDED_VIA_PROMOTION',
  RESERVATION_CHECKOUT = 'ADDED_VIA_RESERVATION_CHECKOUT',
  SUBSCRIPTION_SIGNUP = 'ADDED_VIA_SUBSCRIPTION_SIGNUP',
  TEXT_TO_PAY = 'ADDED_VIA_TEXT_TO_PAY',
  VALET_INVITE = 'ADDED_VIA_VALET_INVITE',
  VALIDATION_FLOW = 'ADDED_VIA_VALIDATION_FLOW',
  VIOLATION_FLOW = 'ADDED_VIA_VIOLATION_FLOW',
}

export enum OnboardingFlow {
  EXPRESS = 'ONBOARDING_FLOW_EXPRESS',
  GENERAL = 'ONBOARDING_FLOW_GENERAL',
  RESERVATION_CHECKOUT = 'ONBOARDING_FLOW_RESERVATION_CHECKOUT',
}

export enum ProfileFieldSource {
  APP_PROFILE_UPDATE = 'PROFILE_FIELD_SOURCE_APP_PROFILE_UPDATE',
  CUSTOMER_SUPPORT = 'PROFILE_FIELD_SOURCE_CUSTOMER_SUPPORT',
  EXPRESS_ONBOARDING = 'PROFILE_FIELD_SOURCE_EXPRESS_ONBOARDING',
  GENERAL_SIGNUP = 'PROFILE_FIELD_SOURCE_GENERAL_SIGNUP',
  PROMOTION = 'PROFILE_FIELD_SOURCE_PROMOTION',
  RESERVATION_CHECKOUT = 'PROFILE_FIELD_SOURCE_RESERVATION_CHECKOUT',
  TEXT_TO_PAY = 'PROFILE_FIELD_SOURCE_TEXT_TO_PAY',
  VALIDATION_FLOW = 'PROFILE_FIELD_SOURCE_VALIDATION_FLOW',
  VALET_INVITE = 'PROFILE_FIELD_SOURCE_VALET_INVITE',
  VIOLATION_FLOW = 'PROFILE_FIELD_SOURCE_VIOLATION_FLOW',
}

export enum ReferralPartner {
  BILT = 'REFERRAL_PARTNER_BILT',
  PARKING_DOT_COM = 'REFERRAL_PARTNER_PARKING_DOT_COM',
  RESORTS_WORLD = 'REFERRAL_PARTNER_RESORTS_WORLD',
  SPOTHERO = 'REFERRAL_PARTNER_SPOTHERO',
}

export enum ClientPlatform {
  WEB = 'CLIENT_PLATFORM_WEB',
}
